<template>
  <div id="map-container"></div>
</template>

<script>
import {fetch} from '@/utils/backend'

var infoWin
var tableDom

function openInfoWin(map, event, content) {
  if (!infoWin) {
    infoWin = new AMap.InfoWindow({
      autoMove: false,
      isCustom: true,  //使用自定义窗体
      offset: new AMap.Pixel(130, 100)
    })
  }

  var x = event.offsetX
  var y = event.offsetY
  var lngLat = map.containerToLngLat(new AMap.Pixel(x, y))

  if (!tableDom) {
    let infoDom = document.createElement('div')
    infoDom.className = 'map-info'
    tableDom = document.createElement('table')
    infoDom.appendChild(tableDom)
    infoWin.setContent(infoDom)
  }

  var trStr = ''
  for (var name in content) {
    var val = content[name]
    trStr +=
        '<tr>' +
        '<td class="label">' + name + '</td>' +
        '<td>&nbsp;</td>' +
        '<td class="map-content">' + val + '</td>' +
        '</tr>'
  }

  tableDom.innerHTML = trStr
  infoWin.open(map, lngLat)
}

function closeInfoWin() {
  if (infoWin) {
    infoWin.close()
  }
}

export default {
  name: 'Map',
  data: function () {
    return {
      districts: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const that = this
      fetch('district_devices', {level: 0}).then(({data}) => {
        console.log('district_devices', data)
        setTimeout(() => {
          that.initMap(data.filter(item => item.center != null))
        }, 1000)
      })
    },
    render(districts) {

      const map = new AMap.Map('map-container', {
        mapStyle: 'amap://styles/darkblue',
        zoom: 1,
        features: ['bg', 'road'],
        viewMode: '3D'
      })

      var layer = new Loca.PointLayer({
        eventSupport: true,
        map: map
      })

      layer.on('mousemove', function (ev) {
        // 事件类型
        var type = ev.type
        // 当前元素的原始数据
        var rawData = ev.rawData
        // 原始鼠标事件
        var originalEvent = ev.originalEvent

        openInfoWin(map, originalEvent, {
          '省份': rawData.district,
          '装机数': rawData['数量']
        })
      })

      layer.on('mouseleave', function (ev) {
        closeInfoWin()
      })

      layer.setData(districts, {
        lnglat: function (data) {
          const val = data.value.center.replace('POINT(', '').replace(')', '').split(' ')
          console.log(val)
          return val
        }
      })
      layer.setOptions({
        style: {
          radius: function (data) {
            var item = data.value
            return item['数量']
          },
          color: function (data) {
            var item = data.value
            var count = item['数量']

            if (count > 20) {
              return '#82cf9c'
            } else if (count <= 20 && count >= 10) {
              return '#10b3b0'
            } else {
              return '#00ffb2'
            }
          },
          opacity: 0.84,
          borderWidth: 0,
          borderColor: '#eee'
        },
        selectStyle: {
          color: '#FFF684'
        }
      })

      layer.render()
    },
    initMap(districts) {
      //将数据分类并添加styleId（数据为js文件引入）
      districts.forEach(function (item, index) {
        const val = item.center.replace('POINT(', '').replace(')', '').split(' ')
        console.error(val)
        item.lat = parseFloat(val[1])
        item.lng = parseFloat(val[0])
        if (item['数量'] > 100) {
          item.styleId = "greenStyleColor";
          item.hierarchy = 4;
        } else if (item['数量'] > 50) {
          item.styleId = "yellowStyleColor";
          item.hierarchy = 3;
        } else if (item['数量'] > 10) {
          item.styleId = "blueStyleColor";
          item.hierarchy = 2;
        } else {
          item.styleId = "redStyleColor";
          item.hierarchy = 1;
        }
      });

      //初始化地图
      var map = new TMap.Map("map-container", {
        zoom: 4.4, //设置地图缩放级别
        center: new TMap.LatLng(36.32434341048188, 106.26656561894674), //设置地图中心点坐标
        mapStyleId: "1", //个性化样式
        showControl: false,
        baseMap: {
          type: "vector",
          features: ["base", "building3d"], // 隐藏矢量文字
        },
      });

      //初始化散点图并添加至map图层
      var dot = new TMap.visualization.Dot({
        styles: {
          redStyleColor: {
            type: "circle", //圆形样式
            fillColor: "rgba(148,28,230,0.3)", //填充颜色
            radius: 10, //原型半径
          },
          blueStyleColor: {
            type: "circle", //圆形样式
            fillColor: "rgba(204,24,93,0.9)", //填充颜色
            radius: 20, //原型半径
          },
          yellowStyleColor: {
            type: "circle", //圆形样式
            fillColor: "rgba(204,114,24,0.9)", //填充颜色
            radius: 30, //原型半径
          },
          greenStyleColor: {
            type: "circle", //圆形样式
            fillColor: "#FFD343", //填充颜色
            strokeWidth: 0, //边线宽度
            radius: 40, //原型半径
          },
        },
      })
          .addTo(map)
      dot.setData(
          districts.sort((a, b) => a.hierarchy - b.hierarchy) //显示层级排序
      ); //设置数据
    }
  }
}
</script>

<style>

.map-info {
  background: #363F49;
  color: #A0A7B4;
  padding: 10px;
  font-size: 12px;
}

.map-info tr .map-content {
  text-align: right;
  color: #D3D8E0;
  max-width: 200px;
}
</style>
